import React from 'react';
import { Logo, SiteHeader } from './LandingPageV2';

/* Header and footer shared by the landing subpages (/careers, /contact).
   The header is the landing page's own nav; its section links point back to the home page (/). */

export const SubpageHeader: React.FC = () => <SiteHeader base="/" />;

export const SubpageFooter: React.FC = () => (
  <footer className="mlp-footer">
    <div className="mlp-wrap mlp-footer-inner">
      <div className="mlp-footer-brand">
        <Logo />
        <span>Trustworthy AI for Real Estate</span>
      </div>
      <nav className="mlp-footer-links" aria-label="Footer">
        <a href="/">Home</a>
        <a href="/careers">Careers</a>
        <a href="/contact">Contact</a>
        <a href="/privacy-terms">Privacy &amp; terms</a>
      </nav>
      <span className="mlp-footer-copy">© {new Date().getFullYear()} Metlas Inc</span>
    </div>
  </footer>
);
